import { INewbuildingCount } from '../../types/newBuldings';
import { ITabProps } from '../../components/tabs';

export function getTabs(statuses: INewbuildingCount[]): ITabProps[] {
  return statuses.map(item => ({ value: item.newbuildingStatus, title: item.displayName }));
}
